import React, { Component } from 'react';
import { Col, Grid, Image, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { routes } from '../../constants';
import dog404 from '../../images/dog-404.svg';

class UserNotFound extends Component {
  render() {
    return (
      <section id='error'>
        <Grid>
          <h2>Error finding user account</h2>
          <h1>Oops!</h1>
          <Row className='no-gutter'>
            <Col xs={12} md={4} mdOffset={4}>
              <p>
                {`We can't seem to find your user details. Check your account details and try `}
                <Link to={routes.logout}>logging in again</Link>
                {`. If the problem persists, get in touch with Caddie Support.`}
              </p>
            </Col>
          </Row>

          <Row className='no-gutter'>
            <Col xs={8} xsOffset={2} md={4} mdOffset={4}>
              <Image src={dog404} alt='Not Found' responsive />
            </Col>
          </Row>
        </Grid>
      </section >
    );
  }
}

export default UserNotFound;



// WEBPACK FOOTER //
// ./src/containers/pages/user-not-found.js